<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">
        <div class="">
          <label class="txt-right required">Mã phiếu xuất</label>
          <!-- <div class="p-col"> -->
          <InputText
            disabled
            v-model="code"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="code" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Ngày xuất</label>
          <!-- <div class="p-col"> -->
          <Calendar :disabled="mode == 'view'" v-model="date_obj" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" :showButtonBar="true" :showIcon="true"/>
          <input class="input_tmp_validator" id="date_obj" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Trang trại</label>
          <!-- <div class="p-col"> -->
          <Dropdown :disabled="mode == 'view'" v-model="farm" :options="listFarm" optionLabel="name" placeholder="Chọn" />
          <input class="input_tmp_validator" id="farm" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Loại cua</label>
          <!-- <div class="p-col"> -->
          <Dropdown :disabled="mode == 'view'" v-model="kind" :options="listKind" optionLabel="name" placeholder="Chọn" />
          <input class="input_tmp_validator" id="kind" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Khu vực xuất</label>
          <!-- <div class="p-col"> -->
          <ChooseArea :disabled="mode == 'view'" v-model="record_detail" @input="inputChoose" :editPopup="editPopup"
           :data="listUnit" :showPopupChoose="showPopup" :total="number"
            title="Chọn khu vực - Unit" @closeBg="() => {$emit('closeBg')}" @showBg="() => {$emit('showBg')}"
            :showBg="showBg" :key="keyChoose"/>
          <div v-for="(item, index) in dataText" :key="`dataText-${index}`">
            <div class="d-flex align-items-center justify-content-between " style="width: 30%">
              <span>{{ item.label }}</span>
              <span v-if="mode != 'view'">
                <i class="fa fa-edit" @click="showPopupEdit(index)"></i>
                <i class="fa fa-trash" @click="delChoose(index)"></i>
              </span>
            </div>
          </div>
          <input class="input_tmp_validator" id="record_detail" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số lượng cua được xuất</label>
          <InputNumber
              v-model="number"
              disabled
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :maxFracionDigits="0"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="number" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Trọng lượng ước tính (kg)</label>
          <InputNumber
              v-model="estimate_weight"
              disabled
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :minFractionDigits="2" :maxFracionDigits="2"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="estimate_weight" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Trọng lượng thực tế (kg)</label>
          <InputNumber
              v-model="weight"
              :disabled="mode == 'view'"
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :minFractionDigits="2" :maxFracionDigits="2"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="weight" />
        </div>
        

        <div class="mt-3">
          <label class="txt-right">Hình ảnh ({{ images.length }} / {{maxFiles}})</label>
            
            <input :disabled="mode == 'view'" class="p-inputtext p-component text-box" style="background-color: #EEEEEE;" multiple accept="image/*" name="images[]" type="file" @change="onFileSelect"/>
            <div class="cus-text">- Accepted: PNG, JPG, JPEG, GIF.</div>
            <div class="cus-text">- Maximum upload file size: 500 MB</div>
            <div class="box-images mt-3 text-box row"  v-if="images && images.length">
              <div class="item-img mr-3 col-lg-2 mt-3" v-for="(item, index) in images" :key="index" >
                <div v-if="mode != 'view'" class="button-clear" @click="onFileClear(index)"><img src="../../../assets/ic_clear.svg"/></div>
                <img :src="item.objectURL" width="120" height="120"/>
              </div>
            </div>
            <input class="input_tmp_validator" id="images">
        </div>

        <div class="mt-3">
          <label class="txt-right">Video clip</label>
            
            <input :disabled="mode == 'view'" class="p-inputtext p-component text-box" style="background-color: #EEEEEE;" accept="video/*" name="videos[]" type="file" @change="onFileSelectVideo"/>
            <div class="cus-text">- Chấp nhận: MOV, MP4.</div>
            <div class="cus-text">- Dung lượng tối đa: 500 MB</div>
            <div class="box-images mt-3 text-box"  v-if="videos && videos.length">
              <div class="item-img" v-for="(item, index) in videos" :key="index" >
                <div v-if="mode != 'view'" class="button-clear" @click="onFileClearVideo(index)"><img src="../../../assets/ic_clear.svg"/></div>
                <video controls :src="item.objectURL" width="120" height="120"/>
              </div>
            </div>
            <input class="input_tmp_validator" id="videos">
        </div>
        
        <!-- </div> -->
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else-if="mode == 'add'"
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>
<script>
import DataServices from "@/core/DataServices";
import moment from "moment-timezone";
// import { HotModuleReplacementPlugin } from "webpack";
// import gql from "graphql-tag";
import ApiRepository from "@/core/ApiRepository";
import ChooseArea from "@/components/chooseArea";
export default {
  components: {
    ChooseArea
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    showBg: Boolean
  },
  data() {
    return {
      code: "",
      weight: null,
      estimate_weight: null,
      date_obj: null,
      listFarm: [],
      type: 2,
      selectedType: null,
      typeOptions: [],
      kind: null,
      listKind: [],
      number: 0,
      record_detail: [],
      detail: [],
      images: [],
      videos: [],
      maxFiles: 10,
      maxFileSize: 1048576 * 500,
      imagesDeletes: [],
      farm: {},
      listUnit: [],
      dataText: [],
      showPopup: false,
      keyChoose: 0,
      record_detail_tmp: [],
      editPopup: "",
      listK: []
    };
  },
  async mounted() {
    await this.getListType();
    await this.getListFarm();
    await this.getListKind();
    if (this.mode == "add") {
      var total = await this.getTotalCount();
      var now = new Date();
      var dateImport = `${now.getDate()}${(now.getMonth()+1)}${now.getFullYear()}`;
      this.code = `XC${dateImport}-${total}`;
    }
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.code = this.model.code;
        this.farm = this.model.farm;
        this.weight = this.model.est_weight;
        this.estimate_weight = this.model.weight;
        this.date_obj = moment(this.model.date_obj).format("DD/MM/yyyy");
        var unitName = [];
        var boxObjArr = [];
        this.kind = {id: this.model.kind.id, name: this.model.kind.name, weight: this.model.kind.weight, __typename:"kind"};
        this.model.record_details.map(m => {
          if (!unitName.includes(m.obj_box.unit)) {
            unitName.push(m.obj_box.unit);
          }
          if (!boxObjArr.includes({box: m.obj_box.code, unit: m.obj_box.unit.id})) {
            boxObjArr.push({box: m.obj_box.code, unit: m.obj_box.unit.id});
          }
        })
        var numb = 0;
        unitName.map(u => {
          var box = 0;
          var value = 0;
          boxObjArr.map(b => {
            if (b.unit == u.id) {
              box += 1;
            }
            this.model.record_details.map(r => {
              if (r.obj_box.code == b.box) {
                value += r.number;
              }
            })
          })
          this.dataText.push({
            label: `${u.name}: ${value} cua ${box} hộp`
          })
          numb += value;
        })
        this.number = numb;
        this.selectedType = {id: this.model.kind.type.id, name: this.model.kind.type.name, __typename: "kind_type"};
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
    async "selectedType"() {
      if (!this.$commonFuction.isEmptyObject(this.selectedType)) {
        await this.getListKind().then(() => {
          if (this.model.kind) {
            this.kind = {id: this.model.kind.id, name: this.model.kind.name, weight: this.model.kind.weight, __typename:"kind"};
          }
        });
      }
    },
    async "kind"() {
      await this.getListUnit();
    },
    async "farm"() {
      if (!this.$commonFuction.isEmptyObject(this.farm)) {
        await this.getListUnit();
      }
    }
  },
  methods: {
    delChoose(index) {
      delete this.record_detail[this.record_detail_tmp[index]];
      this.dataText.splice(index, 1);
      this.editPopup = "";
      this.keyChoose++;
    },
    showPopupEdit (index) {
      this.editPopup = this.record_detail_tmp[index];
    },
    async inputChoose(data) {
      this.keyChoose++;
      this.record_detail = data;
      this.editPopup = "";
      this.dataText = [];
      this.detail = [];
      this.record_detail_tmp = [];
      for (const property in data) {
        var unit = this.listUnit.filter(f => f.id == property);
        var box = 0;
        var kind = 0;
        var v = []
        this.record_detail_tmp.push(property);
        data[property].map(m => {
          if (m.value.length > 0) { 
            m.value.map(n => {
              if (n.value) {
                v.push(n);
                kind += n.value
                box++;
              }
            })
          }
        });
        if (kind > 0) {
          this.detail.push({
              value: v,
              id: property
          });
          this.dataText.push({
            label: `${unit[0].name}: ${kind} cua ${box} hộp`
          })
          this.number += kind;
        }
      }
      // console.log("this.detailthis.detail", this.detail);
      // console.log("this.detailthis.detail", this.listUnit);
      var w = 0;
      var listK = [];
      this.listUnit.map(m => {
        this.detail.map(d => {
          if (m.id == d.id) {
            d.value.map(v => {
              if (m.items.length > 0 ) {
                m.items.map(h => {
                  if (h.items.length > 0) {
                    h.items.map(b => {
                      if (b.id == v.id) {
                        var val = v.value;
                        // b.total.map(k => {
                        if (b.total >= val) {
                            w += val * b.weight;
                            listK.push({
                              id: b.id,
                              total: (b.total - val)
                            })
                            return;
                        }
                      }
                    })
                  }
                })
              }
            })
          }
        })
      })
      this.estimate_weight = w;
      this.listK = listK;
    },
    async getTotalCount() {
      var now = new Date();
      var gqLQueryCount = DataServices.countData("record");
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key: {
            type: {_eq: this.type},
            created_at: {_gte: moment(now).tz("Asia/Ho_Chi_Minh").startOf('day').toDate(), _lte:moment(now).tz("Asia/Ho_Chi_Minh").endOf('day').toDate()}
          }
        }
      });
      var total = countRes.data['record_aggregate']['aggregate']['count'] + 1;
      return total >= 10 ? total : `0${total}`;
    },
    removeChip(index) {
      this.selectedType.splice(index, 1);
    },
    async getListType() {
      var gqLQueryList = DataServices.getList("kind_type", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "desc" },
        },
      });
      var listData = resData.data["kind_type"];
      this.typeOptions = listData;
    },
    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "asc" },
        },
      });
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },
    async getListKind() {
      var gqLQueryList = DataServices.getList("kind", {"fields": "id, name, weight"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "asc" },
        },
      });
      var listData = resData.data["kind"];
      this.listKind = listData;
    },
    async getListUnit() {
      if (!this?.farm?.id || !this?.kind?.id) {
        return;
      }
      var gqLQueryList = DataServices.getList("unit", {"fields": `id, name, column, row, obj_boxes(where: {kind_id: {_eq: "${this.kind.id}"}}) {id code row_number column_number, total, weight}`});
      var where = {
          farm_id: {_eq: this.farm.id},
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "asc" },
        },
      });
      var listData = resData.data["unit"];
      var list = [];
      listData.map(m => {
        var rows = [];
        for(let r=1; r <= m.row; r++) {
          var box = [];
          for(let l=1; l <= m.column; l++) {
            m.obj_boxes.map(b => {
              if (b.row_number == r && b.column_number == l) {
                // var kind_in_box_numb = 0;
                // if (b.kind_in_box.length > 0) {
                //   kind_in_box_numb = b.kind_in_box.reduce((a, b) => {return a.number + b.number}).number;
                //   console.log("kind_in_box_numbkind_in_box_numb", kind_in_box_numb);
                // }
                box.push({...b, name: b.code, number: b.total});
              }
            })
            
          }
          rows.push({
            id: `row-${r}`,
            name: `Hàng ${r}`,
            type: "row",
            items: box
          })
        }
        list.push({
          id: m.id,
          name: m.name,
          type: "unit",
          items: rows
        })
      });
      // console.log("console.log", list);
      this.listUnit = list;
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      let date_obj_add = document.getElementById("date_obj");
      if (
        this.date_obj == undefined ||
        this.date_obj == null ||
        this.date_obj == ""
      ) {
        date_obj_add.setCustomValidity("Ngày xuất không được để trống!");
      } else {
        date_obj_add.setCustomValidity("");
      }
      
      let farm_add = document.getElementById("farm");
      if (
        this.$commonFuction.isEmptyObject(this.farm)
      ) {
        farm_add.setCustomValidity("Trang trại không được để trống!");
      } else {
        farm_add.setCustomValidity("");
      }

      let kind_add = document.getElementById("kind");
      if (
        this.$commonFuction.isEmptyObject(this.kind)
      ) {
        kind_add.setCustomValidity("Loại cua không được để trống!");
      } else {
        kind_add.setCustomValidity("");
      }

      let number_add = document.getElementById("number");
      if (
        this.number == undefined ||
        this.number == null ||
        this.number == ""
      ) {
        number_add.setCustomValidity("Số lượng cua được xuất không được để trống!");
      } else if (this.number <= 0) {
        number_add.setCustomValidity("Số lượng cua được xuất phải lớn hơn 0!");
      } else {
        number_add.setCustomValidity("");
      }

      let record_detail_add = document.getElementById("record_detail");
      if (
        this.detail.length <= 0
      ) {
        record_detail_add.setCustomValidity("Khu vực xuất không được để trống!");
      } else {
        record_detail_add.setCustomValidity("");
      }

      let estimate_weight_add = document.getElementById("estimate_weight");
      if (
        this.estimate_weight == undefined ||
        this.estimate_weight == null ||
        this.estimate_weight == ""
      ) {
        estimate_weight_add.setCustomValidity("Trọng lượng thực tế (kg) không được để trống!");
      } else if (this.estimate_weight <= 0) {
        estimate_weight_add.setCustomValidity("Trọng lượng thực tế (kg) phải lớn hơn 0!");
      } else {
        estimate_weight_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateUrl(urlStr) {
      try {
        const url = new URL(urlStr);
        if ((url.protocol === "https:" || url.protocol === "http:") && url.host !== "" && url.pathname !== "") {
          const pattern = new RegExp(
            "^([a-zA-Z]+:\\/\\/)?" + // protocol
              "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
              "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
              "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
              "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
              "(\\#[-a-z\\d_]*)?$", // fragment locator
            "i"
          );
          return pattern.test(urlStr);
        }
        return false;
      }catch(err) {
        console.log(err);
        return false;
      }
    },
    async validatePassword() {
      if (this.password.length < 8) {
        return "Mật khẩu phải có ít nhất 8 ký tự!";
      }
      if (this.password.length > 50) {
        return "Mật khẩu không được quá 50 ký tự!";
      }
      if (!/[A-Z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[0-9]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])/;
      if (!re.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!((/[A-Z]/.test(this.password)) || (/[0-9]/.test(this.password)) || (re.test(this.password)) || (/[a-z]/.test(this.password))))
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      return "";
    },
    async existUsername() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_username_exist", {username: this.username, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    async existEmail() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_email_exist", {email: this.email, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email_direction);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        code: this.code.toUpperCase(),
        detail: this.detail,
        number_export: this.number,
        farm: this.farm,
        kind: this.kind,
        type: this.type,
        weight: this.weight,
        date_obj: this.date_obj,
        estimate_weight: this.estimate_weight,
        listK: this.listK,
        images: this.images,
        videos: this.videos
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    isVideos(file) {
      return /^video\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 10) {
          alert("Chỉ được upload tối đa 10 ảnh");
          return;
        }
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 500MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            // this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    async onFileSelectVideo(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 1) {
          alert("Chỉ được upload tối đa 1 video");
          return;
        }
        let acceptTags = [
          "mov",
          "mp4",
          "MOV",
          "MP4"
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the video file in the following format: mov, mp4"
            );
            return;
          }
        }
        if (files.length + this.videos.length > 1) {
          alert("Video quá số lượng tối đa là 1 file");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isVideos(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Video của bạn đã quá dung lượng 500MB");
          } else {
            if (this.videos.length > 0 && this.videos[0].file === "") {
              this.imagesDeletes.push(this.videos[0]);
            }
            this.videos = [];
            this.videos = this.videos.concat.apply(this.videos, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
    onFileClearVideo(index) {
      let img = this.videos[index];
      // console.log("img", img);
      this.videos.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
  z-index: 9999;
}
.item-img {
  width: 120px;
  height: 120px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
